import { roundToTwoDigits } from "features/Library/Common/utils/roundToTwoDigits";
import { FormatActivityTick } from "../../utils/utils"; // adjusted relative path
import { type DataPoint } from "../../../../../components/charts/types/HorizontalBarChart";

interface ActivityCountItem {
  ReportDate: string;
  Meetings: number;
  Calls: number;
}

const toReportDateString = (date: Date): string =>
  `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}`;

export const formatActivityLineTooltip = (_x: Date, y: number): string => roundToTwoDigits(y);

export const makeMeetingsTooltipFormatter =
  (activityItems: ActivityCountItem[]) =>
  (date: Date, percentage: number): string => {
    // Convert date object to "YYYY-MM-DD" with padded 0's if needed
    // This is the format of the API "ReportDate"
    const dateString = toReportDateString(date);
    const valueIndex = activityItems.findIndex((v) => v.ReportDate === dateString);
    if (valueIndex === -1) return `Total Meetings: 0 | ${percentage}%`;
    return `Total Meetings: ${roundToTwoDigits(activityItems[valueIndex].Meetings)} | ${percentage}%`;
  };

export const makeCallsTooltipFormatter =
  (activityItems: ActivityCountItem[]) =>
  (date: Date, percentage: number): string => {
    // Convert date object to "YYYY-MM-DD" with padded 0's if needed
    // This is the format of the API "ReportDate"
    const dateString = toReportDateString(date);
    const valueIndex = activityItems.findIndex((v) => v.ReportDate === dateString);
    if (valueIndex === -1) return `Total Calls: 0 | ${percentage}%`;
    return `Total Calls: ${roundToTwoDigits(activityItems[valueIndex].Calls)} | ${percentage}%`;
  };

export const makeBarMeetingsTooltipFormatter =
  (totalMeetings: number) =>
  (d: DataPoint): string => {
    const rawValue = (totalMeetings * d.value) / 100;
    // Pie data gives total count of meetings
    return `${roundToTwoDigits(rawValue)} | ${d.value}%`;
  };

export const makeBarCallsTooltipFormatter =
  (totalCalls: number) =>
  (d: DataPoint): string => {
    const rawValue = (totalCalls * d.value) / 100;
    // Pie data gives total count of meetings
    return `${roundToTwoDigits(rawValue)} | ${d.value}%`;
  };

export const makeTotalActivityBarFormatter =
  (totalActivityCounts: Record<string, number>) =>
  ({ value, category }: DataPoint): string => {
    const toDisplay = totalActivityCounts[category];
    return `${FormatActivityTick(category)} | ${roundToTwoDigits(toDisplay)} | ${value}%`;
  };

export default {
  formatActivityLineTooltip,
  makeMeetingsTooltipFormatter,
  makeCallsTooltipFormatter,
  makeBarMeetingsTooltipFormatter,
  makeBarCallsTooltipFormatter,
  makeTotalActivityBarFormatter,
};
